export default __webpack_public_path__ + "3db1f1461e5db8d5bc0a9a959981120a.png";